import { Grid, Stack } from '@mui/material';
import { useMyAssortmentTFunction } from '@retail/my-assortment/i18n';

interface Props {
  selectedUnit: string;
}

export function CalculusHeading({ selectedUnit }: Props) {
  const t = useMyAssortmentTFunction();
  return (
    <Stack bgcolor="grey.50" height={50} justifyContent="center" px={2}>
      <Grid container justifyContent="space-between" width="100%">
        <Grid size={3.5}>{t('myAssortment.productCard.description').toUpperCase()}</Grid>
        <Grid size={4.5}>{t('myAssortment.productCard.condition').toUpperCase()}</Grid>
        <Grid size={4}>{t('myAssortment.productCard.pricePerUnit', { unit: selectedUnit })}</Grid>
      </Grid>
    </Stack>
  );
}
